/* =======================================================================
   PRESS.JS — Rassegna stampa nella pagina "La Nostra Storia"
   =======================================================================
   Ogni voce ha:
     • source    → testata o fonte (es. "Il Tirreno", "Vimeo · Molino Quaglia")
     • date      → data (libera, es. "13.12.2019" o "Sigep 2020")
     • type      → categoria: "stampa" | "tv" | "video" | "social" | "evento"
                   (determina il colore/etichetta del badge)
     • title     → titolo dell'articolo (italiano + inglese)
     • excerpt   → breve estratto/descrizione
     • url       → link dell'articolo (apre in nuova scheda)

   ===  COME AGGIUNGERE UN NUOVO ARTICOLO ===
   Copia un blocco { ... } e modifica i campi. L'ordine qui = l'ordine sul sito.
   ======================================================================= */

// Press / news / events about Massimiliano Ciaffone and Le Simpatiche Canaglie.
// Categories: "stampa" | "tv" | "video" | "social" | "evento"

export const pressItems = [
  {
    source: "Il Tirreno",
    date: "13.12.2019",
    type: "stampa",
    title: {
      it: "Ciaffone, l'imprenditore della pizza che si reinventa a 40 anni",
      en: "Ciaffone, the pizza entrepreneur who reinvented himself at 40",
    },
    excerpt: {
      it: "«Punto sulla qualità di impasti e condimenti.» Il racconto del locale di Rosignano Marittimo firmato da Anna Cecchini.",
      en: '"I focus on the quality of doughs and toppings." Anna Cecchini reports from the Rosignano Marittimo venue.',
    },
    url: "https://share.google/WQtWYn1q0zKfFRgZO",
  },
  {
    source: "Il Tirreno",
    date: "30.10.2021",
    type: "tv",
    title: {
      it: "Le pizze di Massimiliano Ciaffone sbarcano su La 7",
      en: "Massimiliano Ciaffone's pizzas land on La 7",
    },
    excerpt: {
      it: "Partecipazione al programma «Mica pizza e fichi». «Lavoro con passione, mi ritengo un innovatore legato alla tradizione.»",
      en: "Featured on the show «Mica pizza e fichi». «I work with passion, an innovator rooted in tradition.»",
    },
    url: "https://share.google/GPd2rFCAtCQGetuf6",
  },
  {
    source: "Fuori Magazine · Petra",
    date: "Sigep 2020",
    type: "stampa",
    title: {
      it: "Massimiliano Ciaffone: simpatia e rigore",
      en: "Massimiliano Ciaffone: warmth and rigour",
    },
    excerpt: {
      it: "Cristina Viggè racconta il viaggio del pizzaiolo toscano tra Petra 3, Petra 9 e i lievitati dolci di Rosignano.",
      en: "Cristina Viggè tells the journey of the Tuscan pizzaiolo, between Petra 3, Petra 9 and the sweet leavened creations from Rosignano.",
    },
    url: "https://share.google/ctdWqNXS5MX0vAusz",
  },
  {
    source: "Vimeo · Molino Quaglia",
    date: "Pizza Up 2022",
    type: "video",
    title: {
      it: "Pizza Up 2022 · Massimiliano Ciaffone",
      en: "Pizza Up 2022 · Massimiliano Ciaffone",
    },
    excerpt: {
      it: "Showcooking ufficiale al Pizza Up, raccontato dalle riprese di Piero Gabrieli per Molino Quaglia.",
      en: "Official showcooking at Pizza Up, filmed by Piero Gabrieli for Molino Quaglia.",
    },
    url: "https://share.google/0rgL1Ehkq6qCA3r03",
  },
  {
    source: "Instagram",
    date: "2022",
    type: "social",
    title: {
      it: "Dietro le quinte su Instagram",
      en: "Behind the scenes on Instagram",
    },
    excerpt: {
      it: "Uno scatto dall'account di Massimiliano: l'attimo prima della cottura.",
      en: "A frame from Massimiliano's profile: the moment before the bake.",
    },
    url: "https://www.instagram.com/p/CklY5ZZNP9H/",
  },
  {
    source: "Stampa di settore",
    date: "2023",
    type: "stampa",
    title: {
      it: "Le Simpatiche Canaglie nella stampa di settore",
      en: "Le Simpatiche Canaglie in the trade press",
    },
    excerpt: {
      it: "Un altro tassello della rassegna stampa dedicata al laboratorio rosignanese.",
      en: "Another piece in the press review dedicated to the Rosignano laboratory.",
    },
    url: "https://share.google/LMlK4A0A0pk7rOx8h",
  },
  {
    source: "Facebook · Video",
    date: "Evento",
    type: "video",
    title: {
      it: "Una serata in pizzeria — video",
      en: "A night at the pizzeria — video",
    },
    excerpt: {
      it: "Un piccolo film social: i clienti, il forno, la cucina al lavoro.",
      en: "A short social film: guests, oven, kitchen at work.",
    },
    url: "https://www.facebook.com/share/v/1PN5Bk2qH7/",
  },
  {
    source: "Facebook",
    date: "Evento",
    type: "evento",
    title: {
      it: "Eventi e serate a tema",
      en: "Themed events and evenings",
    },
    excerpt: {
      it: "Tra ospiti, libri e degustazioni speciali: gli appuntamenti pubblicati sulla pagina Facebook di Rosignano.",
      en: "Guests, books, and special tastings: the events on our Rosignano Facebook page.",
    },
    url: "https://www.facebook.com/share/p/1FusYKudEa/",
  },
];
